'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlowChildren = function TiFlowChildren(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm28.3 26.7c-2.1 0-4 1.4-4.7 3.3h-5.3c-2.7 0-5-2.2-5-5v-5c1.4 1 3.1 1.7 5 1.7h5.3c0.7 1.9 2.6 3.3 4.7 3.3 2.8 0 5-2.2 5-5s-2.2-5-5-5c-2.1 0-4 1.4-4.7 3.3h-5.3c-2.7 0-5-2.2-5-5v-0.3c2-0.7 3.4-2.5 3.4-4.7 0-2.7-2.3-5-5-5s-5 2.3-5 5c0 2.2 1.4 4 3.3 4.7v12c0 4.6 3.7 8.3 8.3 8.3h5.3c0.7 2 2.6 3.4 4.7 3.4 2.8 0 5-2.3 5-5s-2.2-5-5-5z m0-8.4c1 0 1.7 0.8 1.7 1.7s-0.7 1.7-1.7 1.7-1.6-0.8-1.6-1.7 0.7-1.7 1.6-1.7z m-16.6-11.6c0.9 0 1.6 0.7 1.6 1.6s-0.7 1.7-1.6 1.7-1.7-0.7-1.7-1.7 0.7-1.6 1.7-1.6z m16.6 26.6c-0.9 0-1.6-0.7-1.6-1.6s0.7-1.7 1.6-1.7 1.7 0.7 1.7 1.7-0.7 1.6-1.7 1.6z' })
        )
    );
};

exports.default = TiFlowChildren;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flow-children.js
// module id = 3082
// module chunks = 0